export const validateRegisterStep1Form = (data) => {
  const errors = {};

  // validate email
  if (!data.email) {
    errors.email = "請輸入電郵地址";
  } else if (!/\S+@\S+\.\S+/.test(data.email)) {
    errors.email = "請輸入有效的電郵地址";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateLastName = (lastName, t) => {
  if (!lastName) return t('EnterLastName');
  if (/\d/.test(lastName)) return t('LastNameCannotContainNumbers');
  return "";
};


// Individual validation functions for real-time validation
export const validatePhoneNumber = (phone, t) => {
  if (!phone) return t('EnterPhoneNumber');
  if (!/^\d+$/.test(phone)) return t('OnlyNumbers');
  if (phone.length < 8) return t('InvalidPhoneNumber');
  
  return "";
};

export const validatePhoneNumberbyCode2 = (data, t) => {
  if (!data.phoneNumber2) return "";
  if (!/^\d+$/.test(data.phoneNumber2)) return t('OnlyNumbers');
  if (data.phoneCode === "+852" && data.phoneNumber2.length !== 8) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+853" && data.phoneNumber2.length !== 8) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+86" && data.phoneNumber2.length !== 11) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+81" && data.phoneNumber2.length !== 10) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+880" && data.phoneNumber2.length !== 10) return t('InvalidPhoneNumber');
  return "";
};

// Individual validation functions for real-time validation
export const validatePhoneNumberbyCode = (data) => {
  if (!data.phoneNumber2) return "請輸入聯絡電話";
  if (!/^\d+$/.test(data.phoneNumber2)) return "聯絡電話只能包含數字";
  if (data.phoneCode === "+852" && data.phoneNumber2.length !== 8) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+853" && data.phoneNumber2.length !== 8) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+86" && data.phoneNumber2.length !== 11) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+81" && data.phoneNumber2.length !== 10) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+880" && data.phoneNumber2.length !== 10) return "請輸入有效的電話號碼";
  return "";
};

export const validateEmail = (email, t) => {
  if (!email) return t('EnterEmail');
  if (!/\S+@\S+\.\S+/.test(email)) return t('InvalidEmail');
  return "";
};

// Validation for pet form phone numbers
export const validatePetPhoneNumber = (phone, isRequired = true) => {
  if (!phone && isRequired) return "請輸入聯絡電話";
  if (phone && phone.length < 8) return "請輸入有效的電話號碼";
  return "";
};
